// shared/statusConfig.ts
//
// ONLY source for mapping workflowRun status strings to display labels and color tokens.
// Both Convex backend and React frontend import from this file.

export type StatusEntry = {
  label: string;        // e.g. "Running"
  color: string;        // CSS variable token, e.g. "var(--color-emerald)"
  bgClass: string;      // CSS class for badge backgrounds
};

export const STATUS_CONFIG: Record<string, StatusEntry> = {
  planning:  { label: "Planning",  color: "var(--color-slate)",   bgClass: "status-slate" },
  running:   { label: "Running",   color: "var(--color-emerald)", bgClass: "status-emerald" },
  completed: { label: "Completed", color: "var(--color-blue)",    bgClass: "status-blue" },
  failed:    { label: "Failed",    color: "var(--color-coral)",   bgClass: "status-coral" },
  cancelled: { label: "Cancelled", color: "var(--color-amber)",   bgClass: "status-amber" },
};

export const STATUS_FALLBACK: StatusEntry = {
  label: "Unknown",
  color: "var(--color-slate)",
  bgClass: "status-slate",
};
